import {IComponentController, IComponentOptions} from "angular";
import {CustomerSubscriptionsService} from "../../service/customer-subscriptions.service";
import {
    CustomerSubscriptionStatus,
    UnsubscribeTemplateNames,
    UnsubscribeTemplateTitles
} from "../../model/CustomerSubscriptionStatus";
import {SubscriptionService, ToastNotificationServiceName} from "../../../utils/names/serviceNames";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";
import './customer-subscription-statuses.component.scss';
import {MarketingTemplateType} from "../../../customer_profile/model/MarketingTemplateType";
import {Contact, ContactType} from "../../../contact/model/Contact";


export class CustomerSubscriptionStatusesComponent implements IComponentController {

    public static instance: IComponentOptions = {
        template: require('./customer-subscription-statuses.component.html'),
        controller: [SubscriptionService, ToastNotificationServiceName, CustomerSubscriptionStatusesComponent],
        bindings: {
            'customer': '<',
            'templateType': '@'
        }
    };

    private customer: Contact;
    private templateType: MarketingTemplateType;
    private subscriptions: CustomerSubscriptionStatus[];
    private readonly customerOnlyStatuses = [UnsubscribeTemplateNames.ANNIVERSARY, UnsubscribeTemplateNames.CLOSED_LOAN];


    constructor(private subscriptionService: CustomerSubscriptionsService,
                private toastNotificationService: ToastNotificationService) {
    }

    $onInit(): void {
        this.fetchCustomerSubscriptions();
    }

    private fetchCustomerSubscriptions() {
        this.subscriptionService.getCustomerSubscriptions(this.customer.id, this.templateType)
            .then((resp) => {
                if (resp.status == 200) {
                    let subscriptions = this.filterOptionalCampaigns(resp.data);
                    let subTitles = UnsubscribeTemplateTitles();
                    subscriptions.forEach(s => {
                        s.templateName = subTitles[s.templateName];
                    });
                    this.subscriptions = subscriptions;
                } else {
                    this.notifyFetchSubscriptionsFailed();
                }
            }, (err) => {
                this.notifyFetchSubscriptionsFailed();
            });
    }

    private filterOptionalCampaigns(statuses: CustomerSubscriptionStatus[]): CustomerSubscriptionStatus[] {
        if (this.customer.type === ContactType.CUSTOMER) {
            return statuses;
        } else {
            return statuses.filter(status => !this.customerOnlyStatuses.includes(status.templateName));
        }
    }

    private notifyFetchSubscriptionsFailed() {
        this.toastNotificationService.generateErrorMessage("Failed to fetch customer subscriptions!");
    }
}